"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QR_AUTH_REFRESH_TIMEOUT = exports.QR_AUTH_REFRESH_LIMIT = void 0;
/*
 * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
 *
 * This document is the property of Nettoken Ltd.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Nettoken Ltd.
 */
var QR_AUTH_REFRESH_LIMIT = exports.QR_AUTH_REFRESH_LIMIT = 4;
var QR_AUTH_REFRESH_TIMEOUT = exports.QR_AUTH_REFRESH_TIMEOUT = 15000;